import { BehaviorService } from '@_services/Behavior.service';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-silqpay',
  templateUrl: './silqpay.component.html',
  styleUrls: ['./silqpay.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SILQpayComponent implements OnInit, OnDestroy {
  @Input() SettingForm: FormGroup;
  @Input() silqPayDrop: any;
  isLoadingResults: boolean = false;
  @Input() errorWarningData: any;
  isspinerInfo: boolean = false;
  private _unsubscribeAll$: Subject<void> = new Subject();
  theme_type: string = localStorage.getItem('theme_type');

  constructor(
    private behaviorService: BehaviorService,
    private _mainAPiServiceService: MainAPiServiceService,
    private toastr: ToastrService,
    private cd: ChangeDetectorRef,
  ) {}

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    this.behaviorService.loadingSystemSetting('silq-pay');
  }

  ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  /**
   * save the silq payment data
   */
  saveSilqPay() {
    this.isspinerInfo = true;
    let data: any = {
      GroupName: 'Integrations',
      SubgroupName: 'SilqPay',
      PINPAYMENTSAPIKEY: this.SettingForm.controls['PINPAYMENTSAPIKEY'].value,
      PINPAYMENTSABSORBFEE: this.SettingForm.controls['PINPAYMENTSABSORBFEE'].value,
      SILQPAYLINKDESC: this.SettingForm.controls['SILQPAYLINKDESC'].value,
      SILQPAYSHOWINVDETAILS: this.SettingForm.controls['SILQPAYSHOWINVDETAILS'].value,
      SILQPAYSHOWCHEQUEPAYMENT: this.SettingForm.controls['SILQPAYSHOWCHEQUEPAYMENT'].value,
      SILQPAYSHOWDDPAYMENT: this.SettingForm.controls['SILQPAYSHOWDDPAYMENT'].value,
      SILQPAYSHOWINVOICESTATEMENT1: this.SettingForm.controls['SILQPAYSHOWINVOICESTATEMENT1'].value,
      SILQPAYSHOWINVOICESTATEMENT2: this.SettingForm.controls['SILQPAYSHOWINVOICESTATEMENT2'].value,
      SILQPAYSHOWINVOICESTATEMENT3: this.SettingForm.controls['SILQPAYSHOWINVOICESTATEMENT3'].value,
      SILQPAYSHOWFEEAGRSTATEMENT: this.SettingForm.controls['SILQPAYSHOWFEEAGRSTATEMENT'].value,
      SILQPAYSHOWGLOBALFOOTER: this.SettingForm.controls['SILQPAYSHOWGLOBALFOOTER'].value,
    };
    let data1: any = { Action: 'Update', Data: data };
    this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.isspinerInfo = false;
            this.toastr.success('Updated successfully');
          } else if (
            (response.CODE == 451 || response.CODE == 450) &&
            response.STATUS == 'warning'
          ) {
            this.isspinerInfo = false;
            this.toastr.warning(response.MESSAGE);
          } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
            this.isspinerInfo = false;
            this.toastr.warning(response.MESSAGE);
          } else {
            this.isspinerInfo = false;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspinerInfo = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }
}
